<template>
  <div class="app-container">
    <div class="menu">
      <sidebar class="sidebar-container" :isCollapse="isCollapse"></sidebar>
    </div>
    <div class="route-view" :class="[isCollapse ? 'resize' : '']">
      <navbar></navbar>
      <div class="page">
        <router-view v-slot="{ Component }">
          <transition name="fade-transform" mode="out-in">
            <template v-if="keepAlive">
              <keep-alive>
                <component :is="Component" />
              </keep-alive>
            </template>
            <template v-else>
              <component :is="Component" />
            </template>
          </transition>
        </router-view>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useAppStore } from '@/store/app'

const useApp = useAppStore()

const isCollapse = computed(() => {
  return useApp.isCollapse
})
</script>

<script>
import sidebar from '@/layout/sidebar/index.vue'
import navbar from '@/layout/navbar/index.vue'

export default {
  name: 'Layout',
  components: { sidebar, navbar },
  data() {
    return {}
  },
  computed: {
    keepAlive() {
      return this.$route.meta.keepAlive
    },
  },
}
</script>

<style lang="scss" scoped>
.app-container {
  background-color: #ffffff;
  height: 100%;
  overflow-y: auto;
  .menu {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 0px !important;
      height: 0px;
      cursor: pointer;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
      box-shadow: none;
      cursor: pointer;
    }
    &::-webkit-scrollbar-button {
      display: none;
    }
    &::-webkit-scrollbar-thumb {
      display: none;
    }
  }

  .route-view {
    width: 100%;
    padding-left: 220px;
    height: 100%;
    transition: padding-left 0.1s ease-in-out;
    box-sizing: border-box;
    .page {
      height: calc(100% - 88px);
      overflow-y: auto;
      overflow-x: auto;
      padding: 10px;
      box-sizing: border-box;
      width: 100%;
    }
  }
  .resize {
    padding-left: 64px;
    transition: padding-left 0.1s ease-in-out;
  }
  .fade-transform-leave-active,
  .fade-transform-enter-active {
    transition: all 0.5s;
  }

  .fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }
}
</style>
<style lang="scss">
.user-dpd {
  border-radius: 2px !important;
  background: var(--menu-bg) !important;
  border: 0 !important;
  .el-dropdown-menu__item {
    color: white;
  }
  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: transparent !important;
  }
  .popper__arrow {
    display: none !important;
  }
}
</style>
